import { DotLoader } from 'react-spinners';
import React from 'react';
import { connect } from 'react-redux';

const Loader = function ({ color, isLoading }) {
  return <DotLoader sizeUnit="px" size={50} color={color || '#07A2D1'} loading={isLoading} />;
};

export default connect()(Loader);
